// https://app.growthbook.io/features/mccerts-3255-mc-pro-in-certs-v1
export const MCCERTS_3255_MC_PRO_IN_CERTS_FLAG =
  'mccerts-3255-mc-pro-in-certs-v1'

export type McProInCertsBucket = 'control' | 'variant_1'

// Core's Pro plan (prcng-1195), sold as-is in certs. Only in the tier
// collection Core serves for mc_pro_bucket=variant_1.
export const MC_PRO_PLAN_SLUG = 'pro-prcng-1195-annual-purchase-pass-v1'
